import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const EditSports = () => {
  return (
    <Edit
      title="Редактиране на спорт"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditSports;
